import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import FooterNavigationAutoSearch from "webapp/components/FooterNavigatorAutoSearch/FooterNavigatorAutoSearch";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import { AutoSearchForm } from "webapp/components/AutoSearchForm";
import { devLog } from "utils/devLog";

const policyMap = new Map();
export default function EFGMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [phoneNumber] = useState(props.currState.MemberLookup.phoneNumber);
  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);

  const [firstName, setFirstName] = useState(props.currState.FirstName);
  const [lastName, setLastName] = useState(props.currState.LastName);
  const [firstNameInput, setFirstNameInput] = useState(props.currState.MemberLookup.firstName);
  const [lastNameInput, setLastNameInput] = useState(props.currState.MemberLookup.lastName);
  const [partnerCode, setPartnerCode] = useState(props.context.state.localGroup);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState(undefined);
  const [selectedContact, setSelectedContact] = useState(null);

  const [autoSearchRequired, setAutoSearchRequired] = useState(props.currState?.autoSearchRequired);
  const [contactName, setContactName] = useState(props.currState?.contactName ? props.currState?.contactName : "");
  const [skipMemberSearchLimit, setSkipMemberSearchLimit] = useState(props.currState?.skipMemberSearchLimit);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [displaySelectionComponent, setDisplaySelectionComponent] = useState(false);

  // useEffect(() => {
  //   //devLog(props);
  //   onSubmit();
  // }, []);

  useEffect(() => {
    onSubmit();
    checkDuplicateContact(firstName, lastName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(firstName, lastName);
  }, [contacts]);

  const checkDuplicateContact = (firstName, lastName) => {
    if (firstName !== "" && lastName !== "" && contacts) {
      contacts.map((con, index) => {
        if (
          con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
          con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
        ) {
          setCheckDuplicateName(true);
        }
        return checkDuplicateContact;
      });
    } else {
      setCheckDuplicateName(false);
    }
  };

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
      setDisplaySelectionComponent(success);
    }
  };

  const onNextClick = () => {
    if (typeof props.onNextClick === "function") {
      props.onNextClick();
    }
  };

  const onMemberInfo = (memberInfo, contactInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contactInfo);
    }
  };

  //select Contact function, set selectContact to contactInfo => input
  //
  const onSelect = (sc) => {
    //devLog("selected contact: ", sc);
    setSelectedContact(sc);
    onMemberInfo(memberInfo, sc);
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        memberNumber: memberNumber,
        phoneNumber: phoneNumber,
        firstName: firstNameInput,
        lastName: lastNameInput,
        last8Vin: last8Vin,
        partnerCode: partnerCode,
        searchType: searchType,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        //devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.memberInfo.contacts === "object") {
          if (!json.data.error) {
            setContacts(json.data.memberInfo.contacts);
            // onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts(undefined);
            setMemberInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.memberInfo === "object") {
          if (!json.data.error) {
            setContacts(undefined);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts(undefined);
            setMemberInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts(undefined);
          setMemberInfo(undefined);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts(undefined);
          setMemberInfo(undefined);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setContacts(undefined);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo && !error && displaySelectionComponent ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.Name")}:</b> {memberInfo.name}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmVehicleYear")}:</b> {memberInfo.year}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmVehicleMake")}:</b> {memberInfo.make}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmVehicleModel")}:</b> {memberInfo.model}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmVehicleColor")}:</b> {memberInfo.color === null ? "N/A" : memberInfo.color}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>

      {contacts && !error & displaySelectionComponent && (
        <div className="policyData">
          <div className="policyHeader driverContainer">
            <h4 className="driver-header">{t("description.ContactInformationHeader")}</h4>
            <hr />
            <>
              {contacts.map((contact, index) => {
                return (
                  <div
                    key={index}
                    value={contact}
                    className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                    onClick={(e) => {
                      onSelect(contact);
                    }}
                  >
                    <div className="contact-list driver-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedContact === contact ? "selected" : ""}
                      />
                      <div value={contact} className="vehicle-list-item-col-1">
                        <h6 value={contact} className="name-h5">
                          {contact.firstName} {contact.lastName}
                        </h6>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          </div>
        </div>
      )}

      {!checkDuplicateName && !error && displaySelectionComponent ? (
        <div className="policyData">
          <div className="policyHeader driverContainer">
            <h4 className="driver-header">{t("description.AddContactInformationHeader")}</h4>
            <hr />
            <>
              <div
                value={undefined}
                className={`vehicle-list-item ${selectedContact === undefined ? "selected" : ""}`}
                onClick={(e) => {
                  onSelect(undefined);
                }}
              >
                <div className="contact-list driver-list">
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedContact === undefined ? "selected" : ""}
                  />
                  <div value={undefined} className="vehicle-list-item-col-1">
                    <h6 value={undefined} className="name-h5">
                      {props.currState.FirstName} {props.currState.LastName}
                    </h6>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      ) : (
        <></>
      )}

      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
